module.exports = __webpack_public_path__ + "img/weaving.59a8dda8.svg";